import { IconButton, Slide, Stack, styled, Toolbar, useMediaQuery } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import Tooltip from '@mui/material/Tooltip'
import dayjs from 'dayjs'
import { isUndefined } from 'lodash'
import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useAuth } from 'react-oidc-context'
import { useSocketData } from '../../../api/websockets/useSocketData'
import MessageQuestionCircleIcon from '../../../assets/icons/MessageQuestionCircle.svg?react'
import { ChangeEmailDialog } from '../../../dialogs/ChangeEmailDialog'
import { TelegramBotDialog } from '../../../dialogs/TelegramBotDialog'
import { useProfileStore } from '../../../store/storeProfile'
import { useUserStore } from '../../../store/storeUser'
import { useWrapperStore } from '../../../store/storeWrapper'
import { UserWalletDTO } from '../../../swagger/dto'
import { theme } from '../../../theme'
import { CoinsEnd } from '../../CoinsEnd'
import { DesktopHeaderActions } from './DesktopHeaderActions'
import { HeaderLogo } from './HeaderLogo'
import { MobileHeaderActions } from './MobileHeaderActions'
import { TelegramWidget } from './TelegramWidget'

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    padding: '0 32px',
    background: 'transparent',
    marginTop: '16px',
    borderRadius: 0,
    [theme.breakpoints.down('sm')]: {
        minHeight: '44px',
        padding: '0 16px',
        marginTop: '0px',
    },
    [theme.breakpoints.up('sm')]: {
        minHeight: '56px',
    },
}))

export const HeaderApp = () => {
    const [open, setOpen] = useState(false)
    const [openTelegramBotDialog, setOpenTelegramBotDialog] = useState<boolean>(false)
    const [openTelegramBotDialogByClick, setOpenTelegramBotDialogByClick] = useState<boolean>(false)
    const { isTempUser, hideHeader, stepOnboarding, dialogsOpen, setStepOnboarding } =
        useWrapperStore()

    const { userPersonalData, isUserPersonalDataFetched } = useUserStore((state) => state)
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const auth = useAuth()

    const { data } = useSocketData<UserWalletDTO>('wallet/ws')

    const { setWallet } = useProfileStore((state) => state)

    useEffect(() => {
        if (data) {
            setWallet(data)
        }
    }, [data])

    const [cookies, setCookie] = useCookies(['isShowDailyTelegramDialog'])

    const sholdShowLinkTelegramWidget =
        isUserPersonalDataFetched &&
        !isTempUser &&
        isTempUser !== undefined

    const handleLogin = () => {
        ym(100275765, 'reachGoal', 'ENTERAA')
        auth.signoutRedirect()
    }

    const handleCloseTelegramBotDialog = () => {
        setOpenTelegramBotDialog(false)
    }

    useEffect(() => {
        if (
            dialogsOpen &&
            userPersonalData &&
            userPersonalData.email &&
            userPersonalData.banners?.main_telegram !== true &&
            !userPersonalData.is_new
            // isUndefined(cookies.isShowDailyTelegramDialog)
        ) {
            // setCookie('isShowDailyTelegramDialog', true, {
            //     path: '/',
            //     expires: dayjs(new Date()).add(1, 'day').toDate(),
            // })
            setOpenTelegramBotDialog(true)
        }
    }, [userPersonalData, dialogsOpen])

    return (
        <Slide in={!hideHeader} mountOnEnter unmountOnExit>
            <AppBar
                sx={{
                    left: 0,
                    borderRadius: 0,
                    background: stepOnboarding === 3 ? '#7f7f7f' : '#F9FAFB',
                    zIndex: !isMobile && stepOnboarding === 3 ? 1304 : 1100,
                }}>
                <StyledToolbar>
                    <HeaderLogo />
                    <Grid gap={isMobile ? 1 : 1.5} container alignItems="center">
                        {!isTempUser && (
                            <>
                                {/*<DiscountWidget />*/}
                                {sholdShowLinkTelegramWidget && (
                                    <TelegramWidget
                                        disabled={stepOnboarding === 3}
                                        onClick={() => {
                                            setOpenTelegramBotDialog(true)
                                            setOpenTelegramBotDialogByClick(true)
                                        }}
                                    />
                                )}
                                <CoinsEnd isHeaderApp={true} />
                                <Tooltip title="Техническая поддержка (в будни с 9:00 до 18:00 мск)">
                                    <IconButton
                                        disabled={stepOnboarding === 3}
                                        onClick={() =>
                                            window.open(
                                                'https://t.me/arhiassistant_support',
                                                '_blank',
                                                'noopener',
                                            )
                                        }
                                        size="large"
                                        sx={{
                                            color: '#5A5F72',
                                            background: '#ffffff',
                                        }}>
                                        <MessageQuestionCircleIcon />
                                    </IconButton>
                                </Tooltip>
                                {!isMobile && (
                                    <DesktopHeaderActions disabled={stepOnboarding === 3} />
                                )}
                            </>
                        )}
                        {isMobile && <MobileHeaderActions />}

                        {isTempUser && (
                            <Stack direction="row" gap={1} alignItems="center">
                                <Button
                                    onClick={handleLogin}
                                    sx={{ mt: 0, p: isMobile ? '10px' : 2 }}
                                    variant="outlined"
                                    color="primary">
                                    Войти
                                </Button>
                                <Button
                                    onClick={() => setOpen(true)}
                                    sx={{ mt: 0, p: isMobile ? '10px' : 2 }}
                                    variant="contained"
                                    color="primary">
                                    Зарегистрироваться
                                </Button>
                            </Stack>
                        )}
                    </Grid>
                </StyledToolbar>

                <ChangeEmailDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    isTempUser={isTempUser}
                />
                <TelegramBotDialog
                    hideCheckbox={openTelegramBotDialogByClick}
                    open={openTelegramBotDialog}
                    handleClose={handleCloseTelegramBotDialog}
                />
            </AppBar>
        </Slide>
    )
}
